import React from 'react'

import Media from '../Media'
import Text from '../Text'
import * as styles from './card.module.scss'
import classNames from 'classnames'

export default function Card({
  hat,
  title,
  subtitle,
  titleAs = 'h3',
  hatAs = 'h4',
  subtitleAs = 'body-2',
  media,
  // mediaIsBackground = false,
  ctas: Ctas,
  className,
}) {
  return (
    <li className={classNames('card', styles.card, className)}>
      {media && (
        <Media className={classNames(styles.media, 'card-image')} {...media} />
      )}

      <div className={classNames('card-content', styles.content)}>
        <Text
          hat={hat}
          hatAs={hatAs}
          title={title}
          subtitle={subtitle}
          titleAs={titleAs}
          subtitleAs={subtitleAs}
        />
        {Ctas && <Ctas />}
      </div>
    </li>
  )
}
